<div class="container-chart overflow-x-hidden">
  <mat-card class="chart-card">
    <mat-card-content>
      <!-- Filtros -->
      <div class="filters-section">
        <form [formGroup]="form" class="filters-form">
          <div class="filters-row">
            <mat-form-field class="filter-field" appearance="outline">
              <mat-label>Município</mat-label>
              <mat-select formControlName="municipio" (selectionChange)="onMunicipioChange()">
                @for (municipio of municipiosList; track municipio.id) {
                  <mat-option [value]="municipio.id">{{ municipio.nome }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field class="filter-field" appearance="outline">
              <mat-label>Unidade de Saúde</mat-label>
              <mat-select
                formControlName="unidadeSaude"
                (selectionChange)="onUnidadeSaudeChange()"
              >
                @for (unidadeS of unidadeSaudeList; track unidadeS.id) {
                  <mat-option [value]="unidadeS.id">{{ unidadeS.nome }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field class="filter-field" appearance="outline">
              <mat-label>Contexto</mat-label>
              <mat-select formControlName="contexto" (selectionChange)="onContextoChange()">
                @for (contexto of contextosList; track contexto.id) {
                  <mat-option [value]="contexto.id">{{ contexto.nome }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="relative">
              <mat-form-field class="input-tg px-2" appearance="outline">
                <mat-label>Bairro</mat-label>
                <input
                  matInput
                  [formControl]="bairroInput"
                  placeholder="Digite o bairro"
                  (keyup.enter)="addBairro()"
                />
                <button
                  mat-icon-button
                  matSuffix
                  (click)="addBairro()"
                  aria-label="Adicionar bairro"
                >
                  <mat-icon>search</mat-icon>
                </button>
              </mat-form-field>
              <mat-chip-listbox
                class="absolute flex overflow-y-scroll flex-wrap top-12 z-10 rounded max-h-10 p-2"
                *ngIf="bairrosList.length > 0"
                aria-label="Bairros selecionados"
              >
                <mat-chip
                  *ngFor="let bairro of visibleBairros; let i = index"
                  removable
                  (click)="removeBairro(i)"
                  aria-label="Clique para remover"
                >
                  {{ bairro }}
                </mat-chip>

                <!-- Indicador de itens ocultos -->
                <mat-chip *ngIf="hiddenBairrosCount > 0" disabled>
                  +{{ hiddenBairrosCount }} mais
                </mat-chip>
              </mat-chip-listbox>
            </div>
          </div>

          <div class="filters-row">
            <mat-form-field class="filter-field" appearance="outline">
              <mat-label>Data Início</mat-label>
              <input
                matInput
                [matDatepicker]="pickerInicio"
                formControlName="dataInicio"
                (dateChange)="onDateChange()"
              />
              <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
              <mat-datepicker #pickerInicio></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="filter-field" appearance="outline">
              <mat-label>Data Fim</mat-label>
              <input
                matInput
                [matDatepicker]="pickerFim"
                formControlName="dataFim"
                (dateChange)="onDateChange()"
              />
              <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
              <mat-datepicker #pickerFim></mat-datepicker>
            </mat-form-field>
            <div class="flex px-2 gap-4">
            <button mat-raised-button class="btn-tg" (click)="clearFilters()">
              Limpar Filtros
            </button>
            <button class="btn-icon" [disabled]="loading" matTooltip="Recarregar" (click)="loadChartData()">
              @if (loading) {
                <mat-spinner color="white" diameter="22"></mat-spinner>
              } @else {
                <mat-icon>replay</mat-icon>
              }
            </button>
            </div>
          </div>
        </form>
      </div>

      <!-- Loading -->
      @if (loading) {
        <div class="loading-container">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }

      <!-- Gráfico -->
      @if (!loading && hasData) {
        <div class="chart-container">
          <apx-chart
            [series]="chartOptions.series!"
            [chart]="chartOptions.chart!"
            [xaxis]="chartOptions.xaxis!"
            [dataLabels]="chartOptions.dataLabels!"
            [grid]="chartOptions.grid!"
            [stroke]="chartOptions.stroke!"
            [title]="chartOptions.title!"
            [yaxis]="chartOptions.yaxis!"
            [tooltip]="chartOptions.tooltip!"
            [markers]="chartOptions.markers!"
            [legend]="chartOptions.legend!"
            [colors]="chartOptions.colors!"
          ></apx-chart>
        </div>
      }

      <!-- Sem dados -->
      @if (!loading && !hasData) {
        <div class="no-data-container">
          <p class="no-data-message">Nenhuma medição encontrada com os filtros selecionados.</p>
        </div>
      }
    </mat-card-content>
  </mat-card>

  <!-- Tabela de Pacientes -->
  @if (!loading && hasData) {
    <mat-card class="table-card">
      <mat-card-content>
        <h2 class="table-title">Pacientes com Medições</h2>
          @if (pacientesList.length > 0) {
          <table-list-simple
            [ngClass]="'table-container'"
            [dataSource]="pacientesList"
            [columns]="columns"
            (viewItem)="editItem($event)"
            (deleteItem)="deleteItem($event)"
          />

            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
      </mat-card-content>
    </mat-card>
  }
</div>
